import React from 'react'
import CsvDownloadLink from 'components/CsvDownloadLink'
import AutoTable from 'components/AutoTable'
import { resultsHeaders, tableColumns } from './config'
import { BulkAssignResultsTableProps } from './types'
import { TemplateLinkWrapper, ResultsSection, TableContainer } from './styles'

const BulkAssignResultsTable: React.FC<BulkAssignResultsTableProps> = ({
  formattedResults,
}) => {
  if (!formattedResults || formattedResults.length === 0) {
    return null
  }

  return (
    <ResultsSection>
      <TemplateLinkWrapper>
        <CsvDownloadLink
          autoClick={false}
          data={formattedResults}
          filename={`${new Date().toISOString()}_bulk_license_assignment_results.csv`}
          headers={resultsHeaders}
        >
          Click to Download Results
        </CsvDownloadLink>
      </TemplateLinkWrapper>
      <TableContainer>
        <AutoTable
          bordered={true}
          columns={tableColumns}
          filter={true}
          hover={true}
          rows={formattedResults}
          size="sm"
          sort={true}
        />
      </TableContainer>
    </ResultsSection>
  )
}

export default BulkAssignResultsTable

